module.exports = __webpack_public_path__ + "img/address.61751f11.png";